import React from 'react';
import { Zap, Layers } from 'lucide-react';
import {
  CountriesCoverageBlock,
  DynamicPanelSections,
  FrameworkCard,
  PanelCtaRow,
  ProseBlock,
} from './whatVervestacksUi';

const FRAMEWORK_ICONS = {
  layers: Layers,
  zap: Zap,
};

const WhatVervestacksPanelBody = ({ viewModel, simulatorHref, countryIso }) => {
  if (!viewModel) return null;

  const { frameworkBlocks, sections, countries, cta, presentation } = viewModel;

  return (
    <div className="w-full min-w-0 space-y-4 md:space-y-6">
      {frameworkBlocks.map((block) => {
        const Icon = FRAMEWORK_ICONS[block.icon] || Layers;
        return (
          <FrameworkCard
            key={block.id}
            icon={Icon}
            title={block.title}
            subtitle={block.subtitle}
          >
            <ProseBlock text={block.text} />
          </FrameworkCard>
        );
      })}

      <DynamicPanelSections sections={sections} />

      {countries && <CountriesCoverageBlock countries={countries} />}

      <PanelCtaRow
        cta={cta}
        presentation={presentation}
        simulatorHref={simulatorHref}
        countryIso={countryIso}
      />
    </div>
  );
};

export default WhatVervestacksPanelBody;
